import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/plus-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-9848e3fc")

_pushScopeId("data-v-9848e3fc")
const _hoisted_1 = { class: "shopping-list-page" }
const _hoisted_2 = {
  key: 0,
  class: "shopping-list-page-contents-recommend"
}
const _hoisted_3 = { class: "shopping-list-page-contents-list" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "shopping-list-page-add-area" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "shopping-list-page-add-area-button-image"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ShoppingListRecommendationList = _resolveComponent("ShoppingListRecommendationList")
  const _component_ShoppingCategoryList = _resolveComponent("ShoppingCategoryList")
  const _component_ShoppingCheckedList = _resolveComponent("ShoppingCheckedList")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")
  const _component_ShoppingListEditMenu = _resolveComponent("ShoppingListEditMenu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "shopping-list-page-contents",
      ref: "contentsScrollElement",
      onTouchStart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.contentsTouchStart(...args)))
    }, [
      (_ctx.isExistRecommend)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_ShoppingListRecommendationList, {
              key: _ctx.updateDisplayKey,
              recommendationList: _ctx.recommendationList,
              onClickRecommendation: _ctx.clickRecommendation,
              onClickRecommendationRecipe: _ctx.clickRecommendationRecipe,
              onMoveY: _ctx.contentsVerticalScroll
            }, null, 8, ["recommendationList", "onClickRecommendation", "onClickRecommendationRecipe", "onMoveY"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        (_ctx.uncheckedList)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_ShoppingCategoryList, {
                key: _ctx.updateDisplayKey,
                categoryList: _ctx.uncheckedList,
                noElementMessage: _ctx.noWithoutCheckedListMessage,
                onCheckClick: _ctx.updateCheckFood,
                onEditClick: _ctx.editClick
              }, null, 8, ["categoryList", "noElementMessage", "onCheckClick", "onEditClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.checkedList)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_ShoppingCheckedList, {
                key: _ctx.updateDisplayKey,
                foodList: _ctx.checkedList,
                noElementMessage: _ctx.noCheckedListMessage,
                onCheckClick: _ctx.updateCheckFood,
                onEditClick: _ctx.editClick,
                onOnClear: _ctx.clearCheckedList
              }, null, 8, ["foodList", "noElementMessage", "onCheckClick", "onEditClick", "onOnClear"])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 544),
    _createVNode("div", _hoisted_6, [
      _createVNode("button", {
        class: "shopping-list-page-add-area-button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.appendIngredientScreen(...args)))
      }, [
        _hoisted_7
      ])
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowDesignDialog,
      dialogType: _ctx.designDialogType,
      title: _ctx.designDialogTitle,
      message: _ctx.designDialogMessage,
      negativeLabel: _ctx.designDialogNegativeButtonLabel,
      positiveLabel: _ctx.designDialogPositiveButtonLabel,
      onNegativeClick: _ctx.designDialogNegativeButtonHandler,
      onPositiveClick: _ctx.designDialogPositiveButtonHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "negativeLabel", "positiveLabel", "onNegativeClick", "onPositiveClick"]),
    _createVNode(_component_ShoppingListEditMenu, {
      isShowMenu: _ctx.isShowMenu,
      hasFoodId: _ctx.hasFoodId,
      onDeleteClick: _ctx.deleteFoodFromMenu,
      onFavoriteClick: _ctx.appendFavoriteFromMenu,
      onCancelClick: _ctx.cancelMenu
    }, null, 8, ["isShowMenu", "hasFoodId", "onDeleteClick", "onFavoriteClick", "onCancelClick"])
  ]))
})